export default __webpack_public_path__ + "static/media/forma1.ab32aa34.svg";